import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { List, Button, Icon } from '@pella/sash-framework';
import CTA from '../cta';

import './index.css';

const LocalNavSidebar = ({ navHeading = 'Jump to...', linksArr, children, className, ...other }) => {
	const [showLinks, setShowLinks] = useState(false);
	const [activeLink, setActiveLink] = useState(linksArr?.[0]?.link?.title);

	useEffect(() => {
		if (!linksArr?.length > 0) return;

		document.addEventListener('scroll', onWindowScroll, { passive: true });
		return () => document.removeEventListener('scroll', onWindowScroll, { passive: true });
	}, [linksArr?.length]);

	if (!linksArr?.[0]) return null;

	const onTriggerClick = () => setShowLinks(!showLinks);

	const onLinkClick = (title) => {
		setActiveLink(title);
		setShowLinks(false);
	};

	const onWindowScroll = () => {
		if (window.innerWidth > 768) return;

		const localNav = document.querySelector('.stickySidebarCol');
		if (window.scrollY >= 100) {
			localNav?.classList?.add('max-md:shadow-lg');
		} else {
			localNav?.classList?.remove('max-md:shadow-lg');
		}
	};

	return (
		<div
			className={`localNavSidebar top-0 z-10 bg-white p-2 duration-500 max-md:left-0 max-md:inline-block max-md:w-full md:border md:border-neutral-200 md:p-4 ${className || ''}`}
			{...other}
		>
			<Button
				color='secondary'
				className='!flex !w-full flex-row items-center justify-between border-2 !p-2 max-md:mx-auto max-md:!pl-3 md:!hidden'
				size='sm'
				onClick={onTriggerClick}
			>
				<span className='flex-1 text-center'>{activeLink}</span>
				<Icon
					name='arrow_drop_down'
					className='ml-2 flex-none'
					size={30}
				/>
			</Button>

			<List
				bullets='none'
				className={`max-md:divide-y-neutral-100 max-md:divide-y max-md:border-2 max-md:border-t-0 max-md:border-black md:space-y-4 ${showLinks ? 'max-md:block' : 'max-md:hidden'}`}
			>
				{navHeading && <li className='text-sm uppercase text-neutral-400 max-md:hidden'>{navHeading}</li>}

				{linksArr.map((link, index) => (
					<li key={index}>
						<CTA
							data={link}
							onClick={() => onLinkClick(link.link.title)}
							className={`inline-block text-sm font-semibold leading-tight hover:decoration-primary max-md:px-4 max-md:py-3 max-md:uppercase ${activeLink === link.link.title ? 'decoration-primary' : 'decoration-transparent'}`}
						/>

						{link.childArr?.[0] && (
							<List
								bullets='none'
								className='space-y-2.5 px-6 py-4 max-md:border-t max-md:border-t-neutral-100 md:mt-2 md:px-4 md:py-0'
							>
								{link.childArr.map((childLink, childIndex) => (
									<li key={childIndex}>
										<CTA
											data={childLink}
											onClick={() => onLinkClick(childLink.link.title)}
											className={`inline-block text-xs font-normal decoration-transparent hover:decoration-primary max-md:px-2 max-md:uppercase md:text-sm`}
										/>
									</li>
								))}
							</List>
						)}
					</li>
				))}
			</List>
			{children}
		</div>
	);
};

LocalNavSidebar.propTypes = {
	navHeading: PropTypes.string,
	linksArr: PropTypes.array,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default LocalNavSidebar;
